'use client'

import {usePageContext}         from '@/context/PageContext'
import cn                       from 'classnames'
import {usePathname, useRouter} from 'next/navigation'
import React                    from 'react'

import styles from './Languages.module.scss'

const Languages = () => {
	const router              = useRouter()
	const pathname            = usePathname()
	const {
		      lang,
	      }                   = usePageContext()
	const handleLanguageClick = (newLang: string) => {
		let newPath = pathname

		if (pathname.startsWith(`/${lang}`)) {
			newPath = pathname.replace(`/${lang}`, `/${newLang}`)
		} else {
			newPath = `/${newLang}${pathname}`
		}

		router.push(newPath)
	}
	return (<div
		className={styles[`languages`]}
	>
		<button
			className={cn(styles[`language`], {[styles['language--active']]: lang === 'fr'})}
			onClick={() => handleLanguageClick('fr')}
			data-cursor-pointer={true}
		>FR
		</button>
		<button
			className={cn(styles[`language`], {[styles['language--active']]: lang === 'en'})}
			onClick={() => handleLanguageClick('en')}
			data-cursor-pointer={true}
		>EN
		</button>
	</div>)
}

export default Languages
